import { cn } from '@repo/ui/lib'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-3.5 py-1 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    defaultVariants: {
      variant: 'default',
    },
    variants: {
      variant: {
        at_drop_off: 'bg-[#F6731514] text-[#FF862F] border-none',
        at_pickup: 'bg-[#F19F0D14] text-[#F19F0D] border-none dark:bg-[#F19F0D40]',
        cancelled: 'bg-[#343A40]/[0.08] text-[#343A40] border-none',
        completed: 'text-[#219653] border-none bg-[#219653]/[0.08]  dark:bg-[#219653]/[0.35]',
        confirmed: 'bg-[#68C40A0F] text-[#68C40A] border-none bg-[#68C40A40]',
        contact_me: ' text-[#FEC601] border-none bg-[#FEC601]/[0.08] dark:bg-[#FEC601]/[0.35]',
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        expired: 'text-[#A5A5A5] border-none bg-[#343A4014]/[0.08]',
        in_transit: 'bg-[#3182CE14] text-[#3182CE] border-none bg-[#3182CE40]',
        issue:
          'text-[#D34053] border-none bg-[#D34053]/[0.08] bg-[#D34053] dark:bg-[#D34053]/[0.35]',
        outline: 'text-foreground',
        outline_danger: 'text-[#CD0003] border-[#CD0003] bg-transparent',
        quoted: 'text-[#06c629] border-none bg-[#06c629]/[0.08]  dark:bg-[#06c629]/[0.35]',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        to_be_quoted: 'bg-[#379ef9]/[0.08] text-[#379ef9] border-none dark:bg-[#379ef9]/[0.35]',
      },
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
